module.exports = __webpack_public_path__ + "img/image128.f163ef46.png";